export function NotificationsIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.0002 18.125C10.9168 18.125 11.6668 17.375 11.6668 16.4583H8.3335C8.3335 17.375 9.0835 18.125 10.0002 18.125ZM15.0002 13.125V8.95833C15.0002 6.4 13.6418 4.25833 11.2502 3.69167V3.125C11.2502 2.43333 10.6918 1.875 10.0002 1.875C9.3085 1.875 8.75016 2.43333 8.75016 3.125V3.69167C6.36683 4.25833 5.00016 6.39167 5.00016 8.95833V13.125L3.3335 14.7917V15.625H16.6668V14.7917L15.0002 13.125ZM13.3335 13.9583H6.66683V8.95833C6.66683 6.89167 7.92516 5.20833 10.0002 5.20833C12.0752 5.20833 13.3335 6.89167 13.3335 8.95833V13.9583Z"
        fill="currentColor"
      />
    </svg>
  )
}
